<template>
<!--质检回复相关-->
<!-- qualityStatus -1无需质检，0质检回复，1质检中，2质检成功，3质检失败 -->
<div class="money-box" >
  <div class="money-text" v-if="detail.qualityStatus===1">您的订单正由保险公司质检中，质检通过后会向您签发保单，请耐心等待审核结果。</div>
  <div class="money-text" v-else-if="detail.qualityStatus===0">经保险公司审核，您本次投保质检不通过，请点击按钮查看详情并进行回复，质检通过后会向您签发保单。</div>
  <div class="money-text" v-else-if="detail.qualityStatus===3">经保险公司审核质检不通过，审核已终止，订单将进行撤单处理，保费会在1-3个工作日内原路退回。</div>
  <div class="btn-list">
    <div class="btn blue" v-if="detail.qualityStatus===0&&detail.qualityUrl" @click="jumpPage(detail.qualityUrl)" >质检回复</div>
  </div>
</div>
</template>

<script>
import {common} from "@/api/mixins";
export default {
  mixins:[common],
  props: ["detail"],
  components: {},
  data() {
    return {
    };
  },
  methods: {},
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.money-box {
  padding: 0 30px 30px;
  background-color: #fff;
  margin-top: 20px;
  .money-text {
    height: 90px;
    font-size: 28px;
    display: flex;
    align-items: center;
    span {
      color: #377AFF;
    }
  }
  .btn-list {
    text-align: right;
    margin-top: 20px;
    .btn {
      width: 160px;
      text-align: center;
      line-height: 60px;
      border: 1px solid #C4C7CD;
      font-size: 26px;
      color: #333;
      display: inline-block;
      border-radius: 30px;
      margin-left: 20px;
      position: relative;
      &:first-child {
        margin-left: 0;
      }
      &.blue {
        border-color: #236DFF;
        color: #377AFF;
      }
    }
  }
}
</style>
